import { useContext } from "react";
import { useLoanCalculatorBase } from "../../../loanApplication/SummaryAndAdjust/shared/hooks/useLoanCalculator/useLoanCalculatorBase";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { getPricingIdByModelVersionCodeAndAgentId } from "../utils/getPricingsByModelVersionCodeAndAgentId";

export const useLoanCalculatorWithPrincipalAmount = () => {
  const {
    state: { loan, asset },
    dispatch,
  } = useContext(ProcessContext);

  const {
    loanConditions,
    setLoanConditionsByTerm,
    patchSetLoanCalculator,
    setLoanConditions,
    termMarks,
    minTerm,
    maxTerm,
  } = useLoanCalculatorBase();

  const getLoanCalculatorByPrincipalAmount = (principal) => {
    if (!asset) return;

    let pricingIds;

    if (asset) {
      const newPricingId = getPricingIdByModelVersionCodeAndAgentId({
        modelVersion: asset.model_version,
        modelVersionCode: asset.model_version_code,
        agentId: loan.agent_id,
        registrationDate: asset.specs?.registration_date,
      });
      //currently only sending one pricingId, instead of an array of pricingIds
      pricingIds = newPricingId;
    }

    if (loan.id && principal) {
      dispatch({
        type: "REQUEST_GET_AVAILABLE_LOAN_CALCULATORS_BY_PRINCIPAL_AMOUNT",
        payload: {
          loanId: loan.id,
          principal,
          pricingIds,
        },
      });
    }
  };

  return {
    loanConditions,
    setLoanConditionsByTerm,
    getLoanCalculatorByPrincipalAmount,
    patchSetLoanCalculator,
    setLoanConditions,
    termMarks,
    minTerm,
    maxTerm,
  };
};
